import { FormEvent } from "react";

export default function extractFormData(form: FormEvent){
    const data: FormData = new FormData(form.target as HTMLFormElement);
    const values = Object.fromEntries(data.entries()) as Record<string, unknown>;
    return values;
}

export function extractFormDataFromElm(form: HTMLFormElement){
    const data: FormData = new FormData(form);
    const values = Object.fromEntries(data.entries()) as Record<string, unknown>;
    return values;
}